// @core/api/endpoints/attachment/delete_attachments_bulk.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DeleteAttachmentsBulkResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Delete multiple attachments
 * Deletes multiple attachments in a single request. Returns lists of successfully deleted IDs and failed IDs with error details. Authorization is checked for each attachment.
 */
export async function DeleteAttachmentsBulk(
  options?: RequestOptions
): Promise<DeleteAttachmentsBulkResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/bulk`;
  const requestOptions = options;
  return client.delete<DeleteAttachmentsBulkResponse>(requestPath, requestOptions);
}
